import React, { useState, useContext } from "react";
import classnames from "classnames";
import Styles from "./TypesOfLoads.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import { useTranslation } from "next-i18next";
import Link from "next/link";

//Icons
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";
import AppImg from "components/utils/AppImg";
import { ga4sendEvent } from "@vahak/core/dist/_services/user-analytics.service";
import { GA4EventNames, GA4ServicePageOnlineLoadBookingEventValues } from "@vahak/core/dist/constants/event-names";

interface TypesOfLoadsProps {
    loadTypes: any;
    sectionTitle: string;
    sectionText: string;
}
interface DataProps {
    id: number;
    type: string;
    description: string;
    image: string;
    srcset: string;
    btnURL: string;
    odc: any;
    count: number;
    topStates: any;
}
interface TopStateProps {
    srcset: string;
    image: string;
    state: string;
}

const TypesOfLoads = ({ loadTypes, sectionTitle, sectionText }: TypesOfLoadsProps) => {
    const { isMobile } = useContext(AppContext);
    const [isActive, setisActive] = useState(0);
    const { t } = useTranslation("servicePages");

    const handleIsActive = (e: number) => {
        setisActive(e);
    };

    return (
        <section className={Styles.main}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.heading}>
                    <h2>{sectionTitle}</h2>
                    <p>{sectionText}</p>
                </div>
                <div className={Styles.lorryTypesBox}>
                    <div className={Styles.lorryTypesNav}>
                        <ul>
                            {loadTypes.map((data: DataProps) => (
                                <li
                                    className={isActive === data.id ? Styles.active : ""}
                                    onClick={() => handleIsActive(data.id)}
                                    key={data.id}
                                >
                                    {data.type}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={Styles.lorryTypeCardWrap}>
                        {loadTypes.map((data: DataProps) => (
                            <div
                                className={classnames(Styles.lorryTypeCard, isActive === data.id ? Styles.active : "")}
                                key={data.id}
                            >
                                <div className={Styles.lorryImage}>
                                    <div className={Styles.imgBox}>
                                        <AppImg
                                            src={data.image}
                                            layout="responsive"
                                            alt={data.type}
                                            width={isMobile ? "230" : "755"}
                                            height={isMobile ? "148" : "460"}
                                        />
                                    </div>
                                </div>
                                <div className={Styles.lorryText}>
                                    <h3>{data.type}</h3>
                                    {/* <p>{data.description}</p> */}
                                    <h4 className={Styles.count}>{data.count}</h4>
                                    <span className={Styles.label}>
                                        {t("servicePages:online-load-booking.TypesOfLoads.postings-of")} {data.type}{" "}
                                        {t("servicePages:online-load-booking.TypesOfLoads.on-Vahak")}
                                    </span>
                                    {/* <ul>
                                        {data.odc.map((odc: string) => (
                                            <li>{odc}</li>
                                        ))}
                                    </ul> */}

                                    <div className={Styles.topStateRow}>
                                        {data.topStates &&
                                            data.topStates.map((topState: TopStateProps, index: number) => (
                                                <div className={Styles.stateCol} key={index}>
                                                    <div className={Styles.stateCard}>
                                                        <AppImg
                                                            src={topState.image}
                                                            layout="responsive"
                                                            alt={topState.state}
                                                            width={isMobile ? "100" : "170"}
                                                            height={isMobile ? "79" : "134"}
                                                        />
                                                        <h5>{topState.state}</h5>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>

                                    <span className={Styles.label}>
                                        {" "}
                                        {t("servicePages:online-load-booking.TypesOfLoads.top-locations-for")}{" "}
                                        {data.type}
                                    </span>
                                    <div className={Styles.bookBtnWrapper}>
                                        <Link href={data.btnURL}>
                                            <a
                                                target="_blank"
                                                onClick={() => {
                                                    ga4sendEvent(GA4EventNames.Servicepage_online_load_booking, {
                                                        value: GA4ServicePageOnlineLoadBookingEventValues.type_of_truck_loads_find_now
                                                    });
                                                }}
                                            >
                                                {t("servicePages:online-load-booking.TypesOfLoads.find-loads-now")}
                                                <ArrowRightWhite />
                                            </a>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TypesOfLoads;
